export default function BotPromptSuggestions({
  prompts,
  onSelect,
}: {
  prompts: string[];
  onSelect: (q: string) => void;
}) {
  return (
    <div className="flex flex-col space-y-2">
      {prompts.map((p) => (
        <button
          key={p}
          onClick={() => onSelect(p)}
          className="rounded-xl bg-gray-800 text-white px-3 py-2 text-sm shadow hover:bg-gray-700 transition"
        >
          {p}
        </button>
      ))}
    </div>
  );
}
